module.exports = __webpack_public_path__ + "static/img/defHeadImg_join.6222eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/defHeadImg_join.png
// module id = p36P
// module chunks = 1